import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { imgUrl } from "@/lib/api";

export const Lightbox = ({ photos, index, onClose, onIndex }) => {
  const open = index !== null && index !== undefined;
  const go = (d) => onIndex((index + d + photos.length) % photos.length);

  useEffect(() => {
    if (!open) return;
    const k = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") go(1);
      if (e.key === "ArrowLeft") go(-1);
    };
    window.addEventListener("keydown", k);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", k); document.body.style.overflow = ""; };
  });

  if (!open) return null;
  return createPortal(
    <div className="fixed inset-0 z-[100] bg-espresso/97 flex items-center justify-center" data-testid="lightbox" onClick={onClose}>
      <button
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="absolute top-4 right-4 sm:top-6 sm:right-6 z-10 flex items-center gap-2 rounded-full border border-seta/25 bg-espresso/70 px-4 py-2.5 text-seta backdrop-blur-sm hover:border-oro hover:text-oro transition-colors duration-300"
        data-testid="lightbox-close"
        aria-label="Chiudi"
      >
        <X size={22} strokeWidth={1.6} />
        <span className="hidden sm:inline font-mono text-[11px] tracking-[0.2em] uppercase">Chiudi</span>
      </button>
      <button onClick={(e) => { e.stopPropagation(); go(-1); }} className="absolute left-2 sm:left-8 text-seta/55 hover:text-oro transition-colors duration-500 p-3" data-testid="lightbox-prev" aria-label="Precedente"><ChevronLeft size={34} strokeWidth={1} /></button>
      <img key={index} onClick={(e) => e.stopPropagation()} src={imgUrl(photos[index])} alt="" className="max-h-[86vh] max-w-[88vw] object-contain animate-in fade-in duration-500" />
      <button onClick={(e) => { e.stopPropagation(); go(1); }} className="absolute right-2 sm:right-8 text-seta/55 hover:text-oro transition-colors duration-500 p-3" data-testid="lightbox-next" aria-label="Successiva"><ChevronRight size={34} strokeWidth={1} /></button>
      <span className="absolute bottom-7 left-1/2 -translate-x-1/2 font-mono text-[11px] tracking-[0.2em] text-seta/55" data-testid="lightbox-counter">{index + 1} / {photos.length}</span>
    </div>,
    document.body
  );
};
